'use strict';

App.controller('AppSuccessCtrl', ['$scope', '$state', '$localStorage',
    function ($scope, $state, $localStorage) {
        var token = $localStorage['token'];
        if (token) {
            // allowed to access this controller
        } else {
            window.location.hash = '/login';
            window.location.reload();
        }

        var viewModel = this;
        viewModel.submit = submit;

        // =============to submit details=============
        function submit() {
            $state.go('splash');
        }

    }]);
